export default {
  switchOrganization: "Changer d'organisation",
  noOrganizations: 'Aucune organisation trouvée',
  createNew: 'Créer une organisation',
  createSubtitle: 'Nouvel espace',
  manageOrganizations: 'Gérer les organisations',
  current: 'Actuelle',
  switchTo: 'Basculer vers',
  searchPlaceholder: 'Rechercher une organisation...',
  noResults: 'Aucune organisation trouvée',
  errorLoadingOrganizations: 'Erreur lors du chargement des organisations',
  memberCount: '{count} membre | {count} membres',
  members: 'membres',
  inviteLabel: 'Inviter des membres',
  inviteSubtitle: 'Invitez des personnes dans votre organisation',
  // System role display names (org + workspace). Custom roles fall back to
  // their stored name. Lives here (not settings) so role-name translation
  // works wherever the organizations app is used.
  roles: {
    admin: 'Administrateur',
    editor: 'Éditeur',
    member: 'Membre',
    guest: 'Invité',
    viewer: 'Lecteur',
    owner: 'Propriétaire',
  },
  list: {
    title: 'Organisations',
    subtitle: 'Gérez vos organisations et équipes',
  },
  card: {
    owner: 'Propriétaire',
  },
  switching: {
    loading: "Changement d'organisation...",
  },
  legacy: {
    badge: 'Ancienne interface',
  },
  create: {
    title: 'Créer une organisation',
    subtitle: 'Un espace séparé, avec ses membres et sa facturation',
    modalSubtitle: 'Un espace séparé, avec ses propres membres et sa facturation.',
    previewPlaceholder: 'Votre organisation',
    nextStepsNote: 'Logo, langue et membres se configurent juste après, dans les réglages.',
    error: "La création a échoué. Réessayez dans un instant.",
  },
  form: {
    nameTitle: "Nom de l'organisation",
    nameDescription: "Nom visible par l'ensemble des membres.",
    namePlaceholder: 'Ex. Acme Corp',
    nameRequired: 'Le nom est requis',
    createButton: "Créer l'organisation",
  },
  invite: {
    title: "Inviter dans l'organisation",
    titleSpace: "Inviter dans l'espace",
    context: {
      org: 'Organisation',
      space: 'Espace',
    },
    header: {
      members: '{count} membre(s)',
      expires: 'Expire',
    },
    expiry: {
      today: "aujourd'hui",
      tomorrow: 'demain',
      inDays: 'dans {days} jours',
      inWeeks: 'dans {weeks} semaine(s)',
      onDate: 'le {date}',
    },
    link: {
      title: 'Accès par lien',
      description: 'Toute personne disposant du lien peut rejoindre.',
      create: "Créer un lien d'invitation",
      copy: 'Copier le lien',
      regenerate: 'Régénérer',
      openNew: 'Ouvrir dans un nouvel onglet',
      expires: 'Ce lien expirera',
      expiresNever: 'jamais',
      modifySettings: 'Modifier dans les paramètres',
      protected: 'Protégé par mot de passe',
      maxUses: 'Max : {count} utilisation(s)',
    },
    email: {
      title: 'Inviter des personnes',
      description:
        "Les invités auront accès même sans le lien. Ils recevront un lien d'invitation unique par email.",
      placeholder: 'Ajouter des destinataires',
      hint: 'Tapez un email puis appuyez sur Entrée',
      send: 'Envoyer les invitations',
      bulkImport: 'Import en masse',
      sent: 'Invitations envoyées',
      viewMembers: 'Voir les membres ({count})',
      invalidEmails: 'Certaines adresses email sont invalides',
    },
    settings: {
      title: "Paramètres du lien d'invitation",
      shortTitle: 'Paramètres',
      info: "Ces paramètres s'appliquent au lien d'invitation. Les invitations par email sont toujours valides.",
      actions: 'Actions',
      maxUses: {
        title: "Limite d'utilisations",
        placeholder: 'Sélectionner une limite',
        hint: 'Le lien sera désactivé après avoir atteint cette limite',
        unlimited: 'Illimité',
        uses: '{count} utilisation(s)',
      },
      expiration: {
        title: 'Durée de validité',
        placeholder: 'Sélectionner une durée',
        hint: 'Le lien expirera automatiquement',
        never: 'Jamais',
        '1d': '1 jour',
        '7d': '7 jours',
        '15d': '15 jours',
        '30d': '30 jours',
      },
      regenerate: 'Générer un nouveau lien',
      regenerateHint: "Crée un nouveau lien d'invitation. L'ancien lien restera actif jusqu'à ce que vous le désactiviez.",
      generateBtn: 'Créer un nouveau lien',
      manageHistory: "Gérer les liens dans l'historique",
      manageHistoryHint: 'Voir tous les liens, les activer/désactiver.',
    },
    history: {
      title: "Historique des liens d'invitation",
      cardSubtitle: 'Gérer et consulter tous les liens générés',
      infoCleanup:
        'Les liens expirés et inactifs depuis plus de 90 jours sont automatiquement supprimés.',
      empty: 'Aucun lien généré',
      emptyDescription:
        "L'historique des liens apparaîtra ici une fois que vous aurez généré des liens d'invitation.",
      tabAll: 'Tous',
      active: 'Actif',
      inactive: 'Inactif',
      activate: 'Activer le lien',
      deactivate: 'Désactiver le lien',
      expired: 'Expiré',
      exhausted: 'Épuisé',
      untitled: 'Lien sans nom',
      createdBy: 'par {name}',
      createdOn: 'Créé le {date}',
      expiresIn: 'Expire dans {days} jours',
      noExpiry: "Pas d'expiration",
      usageProgress: '{current} / {max} utilisations',
      usageUnlimited: '{count} utilisation(s)',
    },
    import: {
      title: 'Import en masse',
      infoTitle: "Import intelligent d'emails",
      info: "Collez n'importe quel texte contenant des adresses email. Le système détectera automatiquement tous les emails valides, peu importe le format.",
      label: "Liste d'emails",
      placeholder: 'Collez votre texte ici...',
      detected: '{count} email(s) détecté(s)',
      preview: 'Prévisualisation',
      valid: '{count} valide(s)',
      invalid: '{count} invalide(s)',
      duplicates: '{count} doublon(s) supprimé(s)',
      add: 'Ajouter {count} email(s)',
      clear: 'Tout effacer',
      examplesTitle: 'Exemples de formats de texte acceptés',
    },
    viewMembers: {
      title: 'Voir les membres',
      subtitle: '{count} membres dans cette organisation',
    },
    errors: {
      alreadyMembers: 'Ces emails sont déjà membres de cette organisation :',
      sendFailed: "Erreur lors de l'envoi des invitations à :",
    },
    roleWorkspace: {
      title: 'Rôle & espaces',
      description: "Choisissez le rôle dans l'organisation, puis pour chaque espace le rôle à y attribuer.",
      roleLabel: "Rôle dans l'organisation",
      workspaceLabel: 'Ajouter à un espace',
      workspacePlaceholder: "Sélectionner un espace à ajouter…",
      workspaceAllSelected: 'Tous les espaces sont déjà ajoutés',
    },
    mode: {
      switchToLink: 'Créer un lien de partage',
      switchToLinkHint: 'Partagez un lien pour donner un accès facile, sans saisir les emails.',
      switchToEmail: "Revenir à l'invitation par email",
      linkHistory: 'Historique des liens',
      linkSectionTitle: "Lien d'invitation",
      recipientsTitle: 'Inviter des personnes',
      recipientsDescription: 'Chacune recevra une invitation personnelle par email.',
    },
    access: {
      generalTitle: 'Accès général',
      generalDescription: "Le rôle dans l'organisation attribué à toutes les personnes de cette invitation.",
      spaceTitle: 'Accès à cet espace',
      customizeTitle: 'Donner accès à des espaces privés',
      customizeDescription: "Les espaces publics sont déjà visibles par les membres. Donnez ici l'accès à des espaces privés précis.",
      addWorkspace: 'Ajouter un espace',
      thisSpaceBadge: 'Cet espace',
      memberHint: 'Les membres voient automatiquement tous les espaces publics en Lecteur.',
      adminHint: 'Ce rôle donne accès à tous les espaces en tant qu\'Administrateur.',
      searchPlaceholder: 'Rechercher un espace privé…',
      defaultRole: 'Rôle par défaut',
      selectedCount: '{count} sélectionné(s)',
      selectAll: 'Tout cocher',
      deselectAll: 'Tout décocher',
      noResults: 'Aucun espace ne correspond',
    },
    preview: {
      title: 'Ce à quoi ils auront accès',
      allWorkspaces: 'Tous les espaces',
      grantedTitle: 'Espaces que vous attribuez',
      publicTitle: 'Espaces publics (visibles par défaut)',
      publicCount: '{count} espace(s) public(s)',
      autoViewerNote: 'visible par défaut',
      publicBadge: 'Public',
      privateBadge: 'Privé',
      noWorkspaces: "Membre de l'organisation uniquement — aucun accès à un espace.",
      noWorkspacesInOrg: "Cette organisation n'a pas encore d'espace.",
      toggleNames: 'Détails',
    },
    review: {
      title: "Vérifiez avant d'envoyer",
      recipients: 'Destinataires',
      orgRole: "Rôle dans l'organisation",
      willSee: 'Ils auront accès à',
      editButton: 'Modifier',
      sendButton: 'Envoyer {count} invitation(s)',
    },
    method: {
      link: 'Lien à partager',
      email: 'Par email',
    },
    form: {
      nameLabel: 'Nom du lien (facultatif)',
      nameHelper: "Sert juste à le reconnaître plus tard — un nom daté est utilisé si vous le laissez vide.",
      namePlaceholder: 'ex. Onboarding T1 · équipe marketing',
      defaultName: 'Partage du {date}',
      quotasTitle: 'Limites',
      generateButton: 'Générer le lien',
      sendButton: 'Envoyer les invitations',
    },
    result: {
      title: "Lien d'invitation généré",
      description: "« {name} » est prêt à être partagé. Un lien généré n'est plus modifiable — créez-en un nouveau pour d'autres paramètres.",
      summary: 'Configuration',
      orgRole: "Rôle dans l'organisation",
      workspaces: 'Espaces',
      noWorkspaces: 'Aucun espace',
      createAnother: 'Créer un autre lien',
    },
    toast: {
      linkCreated: "Lien d'invitation créé",
      linkCreateFailed: 'Erreur lors de la création du lien',
      linkActivated: 'Lien activé',
      linkDeactivated: 'Lien désactivé',
      linkUpdated: 'Paramètres du lien mis à jour',
      linkUpdateFailed: 'Erreur lors de la mise à jour du lien',
      linkCopied: 'Lien copié dans le presse-papiers',
      invitesSent: '{count} invitation(s) envoyée(s)',
      invitesFailed: "Erreur lors de l'envoi des invitations",
      emailsAdded: '{count} email(s) ajouté(s)',
    },
  },
}
